<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <div>
            {{ title }}
          </div>
        </div>
        <div class="modal_body">
          <div class="body">
            <div class="oldPassword" v-if="mode === 'master'">
              <div class="label">
                {{ oldPassword }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                type="password"
                id="oldPassword"
                v-model="oldPasswordInput"
              />
            </div>
            <div class="newPassword">
              <div class="label">
                {{ newPassword }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                type="password"
                id="newPassword"
                v-model="newPasswordInput"
              />
            </div>
            <div class="confirmPassword">
              <div class="label">
                {{ confirmPassword }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                type="password"
                id="confirmPassword"
                v-model="confirmPasswordInput"
              />
            </div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="changeButton"
              class="finish_button"
              @click="showConfirmPasswordModal = true"
            />
          </div>
          <div class="modal_window" v-if="showConfirmPasswordModal">
            <confirmPasswordModalWindow
              :question="changeWord"
              @close="close"
              @ok="matching"
            >
            </confirmPasswordModalWindow>
          </div>
          <div class="complete_modal_window" v-if="showCompleteModal">
            <finishModalWindow :question="completeWord" @close="close">
            </finishModalWindow>
          </div>
          <div class="modal_window" v-if="showFailureModal">
            <finishModalWindow :question="failureWord" @close="stayClose">
            </finishModalWindow>
          </div>
          <div class="loading_modal_window" v-if="showloadingModal">
            <loadingModalWindow @close="close"> </loadingModalWindow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import confirmPasswordModalWindow from './confirmModalWindow.vue'
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  props: ['deleteList', 'mode', 'targetId', 'tenantKey'],
  data() {
    return {
      oldPassword: '現在のパスワード :',
      oldPasswordInput: '',
      newPassword: '新しいパスワード :',
      newPasswordInput: '',
      confirmPassword: '新しいパスワードの確認 :',
      confirmPasswordInput: '',
      changeWord: 'パスワードを変更しますか？',
      notMatchPassword: '',
      failureWord: '',
      cancelButton: 'キャンセル',
      changeButton: '変更',
      showConfirmPasswordModal: false,
      showNotMatchPasswordModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false
    }
  },
  components: {
    confirmPasswordModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  computed: {
    backgroundColor() {
      if (
        this.showCompleteModal === true ||
        this.showConfirmPasswordModal === true ||
        this.showFailureModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    title() {
      if (this.mode === 'adminAccount') {
        return 'テナント管理者パスワード変更'
      } else {
        return 'マスター管理者パスワード変更'
      }
    }
  },
  methods: {
    close(e) {
      this.$emit('close')
    },
    stayClose(e) {
      this.showFailureModal = false
    },
    checkPassword(newPassword, confirmPassword) {
      if (newPassword === '' || confirmPassword === '') {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_570003
        this.failureWord =
          this.sysErrorMsg.MSGCRD0055.name +
          this.sysErrorMsg.MSGCRD0055.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        return true
      }
      if (newPassword !== confirmPassword) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_570004
        this.failureWord =
          this.sysErrorMsg.MSGCRD0053.name +
          this.sysErrorMsg.MSGCRD0053.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        return true
      }
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    },
    async matching(e) {
      this.showloadingModal = true
      this.showConfirmPasswordModal = false
      var newPassword = this.newPasswordInput
      var confirmPassword = this.confirmPasswordInput
      var oldPassword = this.oldPasswordInput
      if (this.checkPassword(newPassword, confirmPassword)) {
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      // パスワード更新のコードを追記
      if (this.mode === 'adminAccount') {
        try {
          await this.$store.dispatch(
            'systemAdminDefine/changeAdminUserPassword',
            {
              tenantKey: this.tenantKey,
              userId: this.targetId,
              newPassword: this.newPasswordInput
            }
          )
          this.completeWord = 'パスワードを変更しました。'
          this.showCompleteModal = true
        } catch (error) {
          let eventNumber = this.$store.state.error.sysErrorCode
            .sysErrorCode_570001
          this.createErrorMessage(error, eventNumber, 'MSGCRD0052')
          this.showFailureModal = true
        }
        this.showloadingModal = false
        return
      }
      if (this.mode === 'master') {
        if (oldPassword === '') {
          let eventNumber = this.$store.state.error.sysErrorCode
            .sysErrorCode_570003
          this.failureWord =
            this.sysErrorMsg.MSGCRD0055.name +
            this.sysErrorMsg.MSGCRD0055.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFailureModal = true
          this.showloadingModal = false
          return
        }
        try {
          await this.$store.dispatch(
            'systemAdminDefine/changeMasterUserPassword',
            {previousPassword: oldPassword, newPassword: newPassword}
          )
          this.completeWord = 'パスワードを変更しました。'
          this.showCompleteModal = true
        } catch (error) {
          let eventNumber = this.$store.state.error.sysErrorCode
            .sysErrorCode_570002
          this.createErrorMessage(error, eventNumber, 'MSGCRD0056')
          this.showFailureModal = true
        }
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.modal_container {
  width: 435px;
  height: 380px;
}
.modal_header {
  display: table;
  background-color: #33ccff;
  width: 100%;
}
.modal_header div {
  padding-left: 14px;
  display: table-cell;
  vertical-align: middle;
}
.modal_body {
  height: 332px;
}
.body {
  height: 262px;
  padding-top: 40px;
}
.require_items_label {
  margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/changePasswordModalWindow.vue